import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../_metronic/layout";
import ChangePassword from "./ChangePassword";
import { ProfileCard } from "./components/ProfileCard";
import WalletPage from "./WalletPage";

export default function UserProfilePage() {
  const suhbeader = useSubheader();
  suhbeader.setTitle("پروفایل من");
  return (
    <div className="d-flex flex-row">
      <ProfileCard></ProfileCard>
      <div className="flex-row-fluid ml-lg-8">
        <Switch>
          <Redirect
            from="/user-profile"
            exact={true}
            to="/user-profile/wallet"
          />
          <Route
            path="/user-profile/change-password"
            component={ChangePassword}
          />
          <Route
            path={"/user-profile/wallet"}
            component={WalletPage}
            />
        </Switch>
      </div>
    </div>
  );
}
